<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานพฤติกรรมการค้นหาของผู้ใช้บริการ 
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <!-- <router-link to="/Admin/User_behavior"> -->
            <i class="fa fa-dashboard"></i> รายงานพฤติกรรมของผู้ใช้งาน
          <!-- </router-link> -->
        </li>
      </ol>
    </section>
    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12" style="height:660px;">
            <div class="box box-primary">
              <div class="box-header">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="row">
                    <el-form
                      size="mini"
                      :label-position="label_position"
                      label-width="150px"
                      :model="form"
                      ref="ruleForm"
                      class="demo-ruleForm"
                    >
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <el-form-item label="ประเภทของผู้ให้บริการ" required>
                            <el-select
                              ref="provider_type"
                              v-model="form.provider_type"
                              @change="change_provider"
                              placeholder="กรุณาเลือกประเภทของผู้ให้บริการ"
                              :disabled="isOperator"
                            >
                              <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                              <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="ประเภทของข้อมูลที่ค้นหา" class="is-required">
                            <el-select
                              ref="search_type"
                              v-model="form.search_type"
                              v-if="form.provider_type!=''"
                            >
                              <el-option label="ประเภทการให้บริการ" value="promotion_category"></el-option>
                              <el-option label="ค่าบริการต่ำสุด (บาท)" value="min_price"></el-option>
                              <el-option label="ค่าบริการสูงสุด (บาท)" value="max_price"></el-option>
                              <el-option label="ปริมาณการโทร (นาที)" value="voice_minute_amount" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="อัตราค่าบริการโทร (บาท/นาที)" value="voice_minute_price" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="ปริมาณอินเทอร์เน็ต (GB)" value="internet_amount" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="ค่าบริการอินเทอร์เน็ต (บาท/MB)" value="internet_price" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="ความเร็วอินเทอร์เน็ต (Mbps)" value="internet_speed" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="จำนวนวันที่ให้บริการ" value="number_of_service_days" v-if="form.provider_type == 'mobile'"></el-option>
                              <el-option label="ความเร็วในการดาวน์โหลด (Mbps)" value="download_speed" v-if="form.provider_type == 'broadband'"></el-option>
                              <el-option label="ความเร็วในการอัปโหลด (Mbps)" value="upload_speed" v-if="form.provider_type == 'broadband'"></el-option>
                              <el-option label="ประเภทบริการแพ็กเกจเสริม" value="service_on_top" v-if="form.provider_type == 'broadband'"></el-option>
                              <el-option label="สิทธิพิเศษ" value="privilege"></el-option>
                            </el-select>
                            <el-select
                            v-if="form.provider_type == ''"
                            :disabled="true"
                            value=""
                            >
                            </el-select>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                            <el-form-item label="ประเภทรายงาน" class="is-required">
                                <el-select
                                ref="report_type"
                                v-model="form.report_type"
                                @change="clear_data"
                                >
                                <el-option label="รายเดือน" value="month"></el-option>
                                <!-- <el-option label="ระหว่างเดือน" value="between_month"></el-option> -->
                                <el-option label="รายปี" value="year"></el-option>
                                <!-- <el-option label="ระหว่างปี" value="between_year"></el-option> -->
                                <el-option label="ไตรมาส" value="quarter"></el-option>
                                <!-- <el-option label="ช่วงไตรมาส" value="quarterss"></el-option> -->
                                </el-select>
                          </el-form-item>
                          <el-form-item
                            label="กรุณาเลือกประเภทรายงาน"
                            v-if="form.report_type === ''"
                            class="is-required"
                          >
                            <el-input disabled placeholder></el-input>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.report_type === 'month' ?  '': 'not_display']"
                            class="is-required"
                          >
                            <el-date-picker
                              ref="month"
                              v-model="form.type_data.month"
                              style="width:100%;"
                              :default-value="defaultDate"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.report_type === 'between_month' ?  '': 'not_display']"
                            class="is-required"
                          >
                            <el-date-picker
                              ref="monthfrom"
                              v-model="form.type_data.monthfrom"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>&nbsp;-&nbsp;
                            <el-date-picker
                              ref="monthto"
                              v-model="form.type_data.monthto"
                              style="width:40%;"
                              type="month"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.report_type === 'year' ?  '': 'not_display']"
                            class="is-required"
                          >
                            <el-date-picker
                              ref="year"
                              v-model="form.type_data.year"
                              style="width:100%;"
                              type="year"
                              clearable
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.report_type === 'between_year' ?  '': 'not_display']"
                            class="is-required"
                          >
                            <el-date-picker
                              ref="yearfrom"
                              v-model="form.type_data.yearfrom"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-date-picker
                              ref="yearto"
                              v-model="form.type_data.yearto"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-bind:class="[form.report_type === 'quarter' ?  '': 'not_display']"
                            class="is-required"
                            style="width:100%"
                          >
                            <el-select
                              style="width:30%;"
                              ref="quarter"
                              v-model="form.type_data.quarter"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              ref="quarter_year"
                              type="year"
                              style="width:70%"
                            ></el-date-picker>
                          </el-form-item>
                          <el-form-item
                            label="ช่วงเวลา"
                            v-if="form.report_type === 'quarterss'"
                            v-bind:class="[form.report_type === 'quarterss' ?  '': 'not_display']"
                            class="is-required"
                          >
                            <el-select
                              style="width:15%;"
                              ref="quarterfrom"
                              v-model="form.type_data.quarterfrom"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year_from"
                              ref="quarter_year_from"
                              type="year"
                            ></el-date-picker>&nbsp;&nbsp;-&nbsp;
                            <el-select
                              style="width:15%;"
                              ref="quarterto"
                              v-model="form.type_data.quarterto"
                            >
                              <el-option label="1" value="1"></el-option>
                              <el-option label="2" value="2"></el-option>
                              <el-option label="3" value="3"></el-option>
                              <el-option label="4" value="4"></el-option>
                            </el-select>&nbsp;
                            <el-date-picker
                              v-model="form.type_data.quarter_year"
                              :default-value="defaultDate"
                              ref="quarter_year"
                              type="year"
                            ></el-date-picker>
                          </el-form-item>
                        </div>
                        <div class="col-sm-6">
                          <el-form-item label="การเรียงลำดับ">
                            <el-radio-group v-model="form.order">
                              <el-radio label="DESC">มากที่สุด - น้อยที่สุด</el-radio>
                              <el-radio label="ASC">น้อยที่สุด - มากที่สุด</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>
                      </div>
                    </el-form>
                    <div class="layout_filter_btn">
                      <button type="button" class="btn btn-primary" @click="find_chart()">ค้นหา</button>
                    </div>
                  </div>
                </div>
                <div v-if="displayChart">
                  <div class="col-sm-12" style="text-align:right;padding-bottom: 20px;">
                    <el-button type="primary" @click.prevent="exportDoc">Export Word</el-button>
                  </div>
                </div>
                <div id="chart" class="box-body" ref="chart" v-if="displayChart">
                  <div class="col-sm-12" v-for="chart in this.store_charts" :key="chart.id">
                    <charts class="chart" style="padding-top : 50px; max-height: 500px;" :options="chart" ></charts>
                  </div>
                </div>
                <div class="box-body" v-if="displayText">
                  <div class="col-sm-12">
                    <h4 align="center">ไม่พบข้อมูลที่ต้องการค้นหา</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import Chart from "chart.js"
import { mapState, mapActions } from "vuex";
const moment = require("moment");
import { Document, Packer, Paragraph, Media, AlignmentType } from "docx";
import { saveAs } from "file-saver";
export default {
  data() {
    return {
      showReport: null,
      textShow: "",
      provider_type: "",
      defaultDate: "",
      dynamicDiv: [],
      mixedChart: null,
      label_position: "top",
      isOperator: this.$cookies.get('user_nbtc').provider_id != null ? true : false,
      form: {
        provider_type: this.$cookies.get('user_nbtc').provider_type || '',
        search_type: "",
        type_data: {
          quarterfrom: null,
          quarterto: null,
          yearfrom: null,
          yearto: null,
          monthto: null,
          monthfrom: null,
          monthOfyear: null,
          month: null,
          year: null,
          quarter: null,
          quarter_year_from: null,
          quarter_year: null,
          search_label: ""
        },
        order: "DESC",
        report_type: "",
        year: "",
        quarter: ""
      },
      data: {}
    };
  },
  computed : {
    ...mapState({
      store_charts : store => store.Report_behavior.charts,
      displayChart : store => store.Report_behavior.displayChart,
      displayText : store => store.Report_behavior.displayText 
    })
  },
  mounted() {},
  watch: {
    store_charts : {
      handler: function(reload, empty) {
        // console.log(reload, empty)
      }
    }
  },
  methods: {
    ...mapActions({
      searching: 'Report_behavior/setChartData'
    }),
    clear_data() {
      this.form.type_data = {
        quarterfrom: null,
        quarterto: null,
        yearfrom: null,
        yearto: null,
        monthfrom: null,
        monthto: null,
        month: null,
        monthOfyear: null,
        year: null,
        quarter: null,
        quarter_year_from: null,
        quarter_year: null
      };
    },
    change_provider() {
      this.form.search_type = ""
    },
    exportDoc(){
      this.$html2canvas(this.$refs.chart, { canvas: null }).then(function(canvas) { console.log(canvas) })
      this.$html2canvas(this.$refs.chart, { 
        canvas: null, 
        onclone: function(clone) {
            clone.querySelector('.highcharts-root').style.width = '100%';
            clone.querySelector('.highcharts-root').style.height = 'auto';
            clone.querySelector('.highcharts-root').style.objectFit = 'cover';
          } 
      }).then(function(canvas) {
            const img = canvas.toDataURL("image/png", 1.0);
            const doc = new Document();
            var width = 560;
            var height = width*(canvas.height/canvas.width);
            const image = Media.addImage(doc, img, width, height);
            doc.addSection({
                children: [new Paragraph({children: [image], alignment: AlignmentType.CENTER})],
            });
            Packer.toBlob(doc).then(blob => {
              saveAs(blob, "report.docx");
            });
          });
        },
    find_chart() {
      this.showReport = null
        if (this.form.provider_type == "") {
            this.$alert("กรุณาเลือกประเภทของผู้ให้บริการ", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.provider_type.focus();
            }
            });
            return false;
        } else if (this.form.search_type == "") {
            this.$alert("กรุณาเลือกประเภทของข้อมูลที่ค้นหา", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.search_type.focus();
            }
            });
            return false;
        } else if (this.form.report_type == "") {
            this.$alert("กรุณาเลือกประเภทรายงาน", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.report_type.focus();
            }
            });
            return false;
        } else if (
            this.form.retail_service_provider == "" &&
            this.form.major_service_providers == ""
        ) {
            this.$alert("กรุณาเลือกผู้ให้บริการ", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {}
            });
            return false;
        } else if (
            this.form.report_type == "month" &&
            this.form.type_data.month == null
        ) {
            this.$alert("กรุณาเลือกเดือน", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.month.focus();
            }
            });
            return false;
        } else if (this.form.report_type == "year" && this.form.type_data.year == null) {
            this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.year.focus();
            }
            });
            return false;
        } else if (
            (this.form.report_type == "between_year" &&
            this.form.type_data.yearfrom == null) ||
            (this.form.report_type == "between_year" &&
            this.form.type_data.yearto == null)
        ) {
            this.$alert("กรุณาเลือกปี", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                if (this.form.type_data.yearfrom == null) {
                this.$refs.yearfrom.focus();
                } else {
                this.$refs.yearto.focus();
                }
            }
            });
            return false;
        } else if (
            this.form.report_type == "quarter" &&
            this.form.type_data.quarter == null
        ) {
            this.$alert("กรุณาเลือกไตรมาส", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                this.$refs.quarter.focus();
            }
            });
            return false;
        } else if (
            (this.form.report_type == "quarterss" &&
            this.form.type_data.quarterfrom == null) ||
            (this.form.report_type == "quarterss" &&
            this.form.type_data.quarterto == null) ||
            (this.form.report_type == "quarterss" &&
            this.form.type_data.quarter_year == null) ||
            (this.form.report_type == "quarterss" &&
            this.form.type_data.quarter_year_from == null)
        ) {
            this.$alert("กรุณาเลือกช่วงไตรมาส", "แจ้งเตือน", {
            confirmButtonText: "ตกลง",
            callback: action => {
                if (this.form.type_data.quarterfrom == null) {
                this.$refs.quarterfrom.focus();
                } else if (this.form.type_data.quarterto == null) {
                this.$refs.quarterto.focus();
                } else if (this.form.type_data.quarter_year_from == null) {
                this.$refs.quarter_year_from.focus();
                } else {
                this.$refs.quarter_year.focus();
                }
            }
            });
            return false;
        } else {      
          let tableDiv = document.querySelectorAll('.highcharts-data-table');
          if (tableDiv.length > 0) {
            for(let i = 0; i < tableDiv.length; i++) {
              tableDiv[i].innerHTML = ''
            }
            
          }
          this.form.type_data.search_label = this.$refs['search_type'].selectedLabel
          this.showReport = true
          this.searching(this.form)
        }
       
    }
  }
};
</script>
